import React from 'react'
import { motion } from 'framer-motion'

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
const DEFAULT_START = '2000-01-01'
const DEFAULT_END = '2200-01-01'

const Main = (props) => {

    {/*
    Documentation
        Props:
            active={false/true} - Swaps default styling to active - False by default
            default={false/true} - Enables default styles entirely - True by default ***STYLE MUST BE SET FOR DEFAULT TO BE SET TO FALSE***
            Style={...styles} - Passthrough to styles for complete control - empty by default
            calStartDate={'YYYY-MM-DD'} - The Tuesday that starts the week
            calEndDate={'YYYY-MM-DD'} - The Monday that ends the week
            onClick={function()} - Called when the month label is clicked (e.g. open the modal)
            onMonthChange={function(Date)} - Called by the arrows with the first day of the new month
    */}

    const parseDateString = (value) => {
        if (!value || value === DEFAULT_START || value === DEFAULT_END) return null

        const [year, month, day] = value.split('-').map(Number)
        if (!year || !month || !day) return null

        return new Date(year, month - 1, day)
    }

    // The month is the one that contains the Friday of the week (Tuesday + 3 days, or Monday - 3 days)
    const getWeekFriday = () => {
        const start = parseDateString(props.calStartDate)
        if (start) return new Date(start.getFullYear(), start.getMonth(), start.getDate() + 3)

        const end = parseDateString(props.calEndDate)
        if (end) return new Date(end.getFullYear(), end.getMonth(), end.getDate() - 3)

        return null
    }

    const friday = getWeekFriday()

    const label = friday ? `${MONTHS[friday.getMonth()]} ${friday.getFullYear()}` : 'Select Month'

    const changeMonth = (offset) => {
        const base = friday || new Date()
        props.onMonthChange?.(new Date(base.getFullYear(), base.getMonth() + (friday ? offset : 0), 1))
    }

    const defaultStyle = {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        paddingLeft: '12px',
        paddingRight: '12px',
        borderRadius: '10000px',
        fontWeight: '500',
        height: '100%',
        minHeight: '30px',
        maxHeight: '40px',
        ...(props.active
            ? {
                backgroundColor: props.colors.primary,
                color: props.colors.fontInvert,
            }
            : {
                backgroundColor: props.colors.block,
                border: '1px solid ' + props.colors.border,
                color: props.colors.font,
            }),
    }

    const innerButtonStyle = {
        background: 'none',
        border: 'none',
        color: 'inherit',
        font: 'inherit',
        cursor: 'pointer',
        padding: '0 4px',
    }

    const containerStyle =
        props.Style === undefined
            ? defaultStyle
            : props.default === undefined
                ? { ...defaultStyle, ...props.Style }
                : props.Style

    return (
        <motion.div whileHover={{ scale: 1.03 }} style={containerStyle}>

            <button type="button" style={innerButtonStyle} onClick={props.onClick}>
                {label}
            </button>
            
        </motion.div>
    )
}

export default Main